import React from 'react';
import { render } from 'react-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { MOCK_MODE } from './data/constants';
import fakeServer from './mockServer';

import App from './components/App/';
import MsalApp from './components/MsalApp';
import withLanguageProvider from './hoc/withLanguageProvider';

import { msalConfig } from './authConfig';

import { login } from './settings/settings';
import OIDCApp from './components/OIDCApp';

(process.env.SERVERLESS || MOCK_MODE) && fakeServer();

let msalInstance;
if (login.authType === 'MSAL') {
  msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.enableAccountStorageEvents();
  msalInstance.storeAuthStateInCookie = true;
}


const AppWithLang = withLanguageProvider(App);
const MsalAppWithLang = withLanguageProvider(MsalApp);
const OIDCAppWithLang = withLanguageProvider(OIDCApp);

const AppProvider = () => (
  login.authType === 'MSAL' ?
    <MsalProvider instance={msalInstance}>
      <MsalAppWithLang msalInstance={msalInstance} />
    </MsalProvider> : login.authType === 'OIDC' ?
      <OIDCAppWithLang /> : <AppWithLang />
);

render(<AppProvider />, document.getElementById('crew-interface'));

